import { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { BASE_URL } from "src/app/AppConstants";

export const ShadowWrapper = ({ children }: { children: React.ReactNode }) => {
  const hostRef = useRef<HTMLDivElement | null>(null);
  const [shadowRoot, setShadowRoot] = useState<ShadowRoot | null>(null);
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
      if (hostRef.current && !shadowRoot) {
          const shadow = hostRef.current.attachShadow({ mode: "open" });
          const linkToCss = document.createElement("link");

          linkToCss.rel = 'stylesheet';
          linkToCss.href = `${BASE_URL}/css/MdPreviewStyles.css`;

          shadow.appendChild(linkToCss);
          setShadowRoot(shadow);

          const shadowContainer = document.createElement("div");
          shadowContainer.setAttribute('data-color-mode', 'light');
          shadow.appendChild(shadowContainer);
          setContainer(shadowContainer);
      }
  }, [shadowRoot]);

  return <div className="shadow-host" ref={hostRef}>{container && ReactDOM.createPortal(children, container)}</div>;
};
